export default __webpack_public_path__ + "static/media/habit-tracker.7da83df8.png";